import logo from './logo.svg';
import Giphy from './components/Giphy/Giphy';
// import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Giphy />
      </header>
    </div>
  );
}

export default App;
